<template>
  <div class="loginAds-create-page">
    <div class="global-header-wrap">
      <span v-if="!$route.query.id">{{ $t("commonMsg.new") }}</span>
      <span v-else>{{ $t("commonMsg.edit") }}</span>
      <div>
        <button
          class="global-button-style"
          @click="$router.push({ name: 'loginAds' })"
        >
          {{ $t("commonMsg.back") }}
        </button>
        <button class="global-button-style" @click="submitForm('ruleForm')">
          {{ $t("commonMsg.save") }}
        </button>
      </div>
    </div>
    <el-card
      class="app-table-container"
      :body-style="{ padding: '20px' }"
      v-bar
    >
      <div class="body-wrap">
        <el-form
          label-width="120px"
          :model="form"
          @submit.native.prevent
          ref="ruleForm"
          :rules="rules"
        >
          <el-form-item label="标题" prop="title">
            <el-input
              v-model="form.title"
              class="fl"
              style="width: 200px"
            ></el-input>
          </el-form-item>
          <el-form-item label="发布">
            <el-radio v-model="form.public" :label="0">否</el-radio>
            <el-radio v-model="form.public" :label="1">是</el-radio>
          </el-form-item>

          <el-form-item label="背景色">
            <div class="banners-container">
              <input
                v-show="false"
                ref="bgUploader"
                type="file"
                accept="image/*"
                @change="bgHandleChange"
              />

              <div class="loginAds-bgImgs-main">
                <div class="loginAds-bgImgs-warp">
                  <template v-if="form.bgColor">
                    <el-image
                      class="loginAds-bg-imgs"
                      :src="form.bgColor"
                      fit="fill"
                      :lazy="true"
                      :preview-src-list="[form.bgColor]"
                    ></el-image>
                    <div class="loginAds-bgImgs-btn">
                      <!-- <i
                        class="el-icon-edit"
                        @click.stop="$refs.bgUploader.click()"
                      ></i> -->
                      <i
                        class="el-icon-delete"
                        @click.stop="form.bgColor = ''"
                      ></i>
                    </div>
                  </template>
                </div>
                <div
                  class="loginAds-upload-btn"
                  @click="$refs.bgUploader.click()"
                >
                  <i class="el-icon-plus"></i>
                </div>
              </div>
            </div>
          </el-form-item>

          <el-form-item label="自由轮播">
            <div class="banners-container">
              <input
                v-show="false"
                ref="freeUploader"
                type="file"
                accept="image/*"
                multiple
                @change="freeHandleChange"
              />
              <el-row :gutter="10">
                <template v-if="form.banners.length">
                  <el-col
                    :xs="6"
                    :sm="6"
                    :md="4"
                    :lg="3"
                    :xl="2"
                    v-for="(url, index) in form.banners"
                    :key="url"
                  >
                    <div class="loginAds-imgs-main">
                      <el-image
                        class="loginAds-imgs"
                        :src="url"
                        fit="fill"
                        :lazy="true"
                        :preview-src-list="form.banners"
                      ></el-image>
                      <div class="loginAds-imgs-btn">
                        <!-- <i
                          class="el-icon-edit"
                          @click.stop="editFreeFile(index)"
                        ></i> -->
                        <i
                          class="el-icon-delete"
                          @click.stop="delFreeFile(index)"
                        ></i>
                      </div>
                    </div>
                  </el-col>
                </template>
                <el-col :xs="6" :sm="6" :md="4" :lg="3" :xl="2">
                  <div
                    class="loginAds-upload-btn"
                    @click="$refs.freeUploader.click()"
                  >
                    <i class="el-icon-plus"></i>
                  </div>
                </el-col>
              </el-row>
            </div>
          </el-form-item>

          <el-form-item>
            <el-tabs
              type="border-card"
              v-model="activeTab"
              @tab-click="tabHandleClick"
            >
              <el-tab-pane
                v-for="item in tabOptions"
                :key="item.name"
                :label="item.name"
                :name="item.name"
              >
                <div class="loginAds-tab-item">
                  <p class="loginAds-tab-label">是否显示</p>
                  <div class="loginAds-tab-radio">
                    <el-radio v-model="item.ifShow" label="no">否</el-radio>
                    <el-radio v-model="item.ifShow" label="yes">是</el-radio>
                  </div>
                </div>
                <div class="loginAds-tab-item">
                  <div class="loginAds-tab-label">
                    <p>
                      下载地址
                    </p>
                    <p class="loginAds-tab-icon" @click="addAddrs(item)">
                      <i class="el-icon-plus"></i>
                    </p>
                  </div>
                  <div
                    class="loginAds-tab-addr"
                    v-for="(data, idx) in item.addrs"
                    :key="idx"
                  >
                    <el-input
                      class="loginAds-tab-addrName"
                      size="mini"
                      v-model="data.name"
                      placeholder="地址名称"
                      clearable
                    ></el-input>
                    <el-input
                      class="loginAds-tab-addrVersion"
                      size="mini"
                      v-model="data.version"
                      placeholder="版本号"
                      clearable
                    ></el-input>
                    <el-input
                      class="loginAds-tab-addrUrl"
                      size="mini"
                      v-model="data.addr"
                      placeholder="地址"
                      clearable
                    ></el-input>
                    <p
                      v-if="item.addrs.length !== 1"
                      class="loginAds-tab-icon"
                      @click="delAddrs(item, idx)"
                    >
                      <i class="el-icon-close"></i>
                    </p>
                  </div>
                </div>
              </el-tab-pane>
              <div class="loginAds-tab-item">
                <p class="loginAds-tab-label">关联轮播</p>
                <div class="banners-container">
                  <input
                    v-show="false"
                    ref="relationUploader"
                    type="file"
                    accept="image/*"
                    multiple
                    @change="relationHandleChange"
                  />
                  <el-row :gutter="10">
                    <template v-if="currentTab.banners.length">
                      <el-col
                        :xs="6"
                        :sm="6"
                        :md="4"
                        :lg="3"
                        :xl="2"
                        v-for="(url, index) in currentTab.banners"
                        :key="url"
                      >
                        <div class="loginAds-imgs-main">
                          <el-image
                            class="loginAds-imgs"
                            :src="url"
                            fit="fill"
                            :lazy="true"
                            :preview-src-list="currentTab.banners"
                          ></el-image>
                          <div class="loginAds-imgs-btn">
                            <!-- <i class="el-icon-edit" @click.stop></i> -->
                            <i
                              class="el-icon-delete"
                              @click.stop="delRelationFile(index)"
                            ></i>
                          </div>
                        </div>
                      </el-col>
                    </template>
                    <el-col :xs="6" :sm="6" :md="4" :lg="3" :xl="2">
                      <div
                        class="loginAds-upload-btn"
                        @click="$refs.relationUploader.click()"
                      >
                        <i class="el-icon-plus"></i>
                      </div>
                    </el-col>
                  </el-row>
                </div>
              </div>
            </el-tabs>
          </el-form-item>
        </el-form>
      </div>
    </el-card>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import OSS from "ali-oss";

export default {
  components: {},
  computed: {
    ...mapGetters(["buckets"]),
    rules() {
      return {
        title: [
          {
            required: true,
            message: this.$t("update.inputTitle"),
            trigger: "blur",
          },
        ],
      };
    },
    tabOptions() {
      return this.tabs;
    },
  },
  data() {
    return {
      form: {
        title: "",
        public: 0,
        bgColor: "",
        banners: [],
        clients: [],
      },
      ossClient: null,
      progress: 0,
      activeTab: "iOS",
      currentTab: {
        banners: [],
      },
      tabs: [
        {
          name: "iOS",
          ifShow: "yes",
          banners: [],
          addrs: [
            {
              name: "",
              version: "",
              addr: "",
            },
          ],
        },
        {
          name: "Android",
          ifShow: "yes",
          banners: [],
          addrs: [
            {
              name: "",
              version: "",
              addr: "",
            },
          ],
        },
        {
          name: "macOS",
          ifShow: "yes",
          banners: [],
          addrs: [
            {
              name: "",
              version: "",
              addr: "",
            },
          ],
        },
        {
          name: "Windows",
          ifShow: "yes",
          banners: [],
          addrs: [
            {
              name: "",
              version: "",
              addr: "",
            },
          ],
        },
        {
          name: "Linux",
          ifShow: "yes",
          banners: [],
          addrs: [
            {
              name: "",
              version: "",
              addr: "",
            },
          ],
        },
      ],
    };
  },
  methods: {
    async getDetails() {
      let res = await this.$http.getLoginAdsDetails(this.$route.query.id);
      this.form = res.data;
      this.tabs = JSON.parse(JSON.stringify(this.form.clients));
      for (let item of this.tabs) {
        if (!item.addrs.length) {
          item.addrs.push({
            name: "",
            version: "",
            addr: "",
          });
        }
      }
      this.currentTab = this.tabs[0];
    },

    tabHandleClick(item) {
      this.currentTab = this.tabs[item.index];
    },

    addAddrs(item) {
      item.addrs = [
        ...item.addrs,
        {
          name: "",
          version: "",
          addr: "",
        },
      ];
    },
    delAddrs(item, idx) {
      item.addrs.splice(idx, 1);
    },

    submitForm(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          this.form.clients = JSON.parse(JSON.stringify(this.tabs));
          for (let item of this.form.clients) {
            item.name = item.name === "Window" ? "Windows" : item.name;
            item.addrs = item.addrs.filter((obj) => obj.addr);
          }
          if (this.$route.query.id) {
            this.edit();
          } else {
            this.create();
          }
        } else {
          return false;
        }
      });
    },

    async create() {
      await this.$http.createLoginAds(this.form);
      this.$router.push({ name: "loginAds" });
    },

    async edit() {
      await this.$http.updateLoginAds(this.$route.query.id, this.form);
      this.$router.push({ name: "loginAds" });
    },

    async bgHandleChange(el) {
      let file = el.target.files[0];
      this.ossClient = await this.getOssClient();
      this.form.bgColor = await this.uploadFiles(file);
      this.$refs.bgUploader.value = "";
    },

    async freeHandleChange(el) {
      let files = [...el.target.files];
      this.ossClient = await this.getOssClient();
      for (let file of files) {
        this.form.banners = [
          ...this.form.banners,
          await this.uploadFiles(file),
        ];
      }
      this.$refs.freeUploader.value = "";
    },

    editFreeFile(index) {},
    delFreeFile(index) {
      this.form.banners.splice(index, 1);
    },

    async relationHandleChange(el) {
      let files = [...el.target.files];
      this.ossClient = await this.getOssClient();
      for (let file of files) {
        this.currentTab.banners = [
          ...this.currentTab.banners,
          await this.uploadFiles(file),
        ];
      }
      this.$refs.relationUploader.value = "";
    },

    delRelationFile(index) {
      this.currentTab.banners.splice(index, 1);
    },

    async uploadFiles(file) {
      return new Promise(async (resolve, reject) => {
        try {
          let format = file.name.split(".").pop();
          let key = `loginAds/${this.random_string()}.${format}`;

          this.progress = 0;
          let imgData = await this.ossClient.multipartUpload(key, file, {
            progress: (p) => {
              // progress is generator
              this.progress = parseInt(p.toFixed(2) * 100);
            },
          });
          let url = imgData.res.requestUrls[0].split("?")[0];
          resolve(url);
        } catch (error) {
          reject(error);
        }
      });
    },

    getOssClient() {
      return new Promise(async (resolve, reject) => {
        try {
          let res = await await this.$http.aliyunSts();
          let { region, bucket } = this.buckets["onyx-static"];
          let creds = res.data;
          let client = new OSS({
            region,
            accessKeyId: creds.AccessKeyId,
            accessKeySecret: creds.AccessKeySecret,
            stsToken: creds.SecurityToken,
            bucket,
            secure: true,
          });
          return resolve(client);
        } catch (error) {
          reject(error);
        }
      });
    },

    random_string(len) {
      len = len || 32;
      var chars = "ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678";
      var maxPos = chars.length;
      var pwd = "";
      for (let i = 0; i < len; i++) {
        pwd += chars.charAt(Math.floor(Math.random() * maxPos));
      }
      return pwd;
    },
  },
  created() {
    this.currentTab = this.tabs[0];
  },
  mounted() {
    if (!this.$route.query.id) return;
    this.getDetails();
  },
};
</script>

<style lang="scss">
.loginAds-create-page {
  height: 100%;
  display: flex;
  flex-direction: column;
  .body-wrap {
    /* height: 100%; */
    flex: 1;
    overflow: hidden;
    .el-form {
      width: 80%;
      margin: 10px auto;

      .global-button-style {
        width: 100%;
        margin: 0;
      }
      .banners-container {
        flex: 1;
        display: flex;
        align-items: center;
        .loginAds-bgImgs-main {
          display: flex;
          .loginAds-bgImgs-warp {
            position: relative;
            &:hover {
              .loginAds-bgImgs-btn {
                display: flex;
              }
            }
            .loginAds-imgs {
              width: 80px;
              height: 80px;
              border-radius: 4px;
            }
            .loginAds-bgImgs-btn {
              width: 80px;
              display: none;
              justify-content: space-around;
              align-items: center;
              position: absolute;
              bottom: 11px;
              left: 0;
              box-sizing: border-box;
              padding: 6px;
              background: rgba($color: $globalBGColor, $alpha: 1);
              border-bottom-left-radius: 4px;
              border-bottom-right-radius: 4px;
              > i {
                color: #fff;
                cursor: pointer;
              }
            }
          }
        }
        > .el-row {
          flex: 1;
        }
        .loginAds-imgs-main {
          position: relative;
          &:hover {
            .loginAds-imgs-btn {
              display: flex;
            }
          }
          .loginAds-imgs {
            width: 80px;
            height: 80px;
            border-radius: 4px;
          }
          .loginAds-imgs-btn {
            width: 80px;
            display: none;
            justify-content: space-around;
            align-items: center;
            position: absolute;
            bottom: 11px;
            left: 0;
            box-sizing: border-box;
            padding: 6px;
            background: rgba($color: $globalBGColor, $alpha: 1);
            border-bottom-left-radius: 4px;
            border-bottom-right-radius: 4px;
            > i {
              color: #fff;
              cursor: pointer;
            }
          }
        }
        .loginAds-bg-imgs {
          margin-right: 10px;
          width: 80px;
          height: 80px;
          border-radius: 4px;
        }
        .loginAds-bgUpload-btn {
          margin-left: 10px;
        }
        .loginAds-upload-btn,
        .loginAds-bgUpload-btn {
          width: 78px;
          height: 78px;
          border: 1px dashed #c0ccda;
          border-radius: 4px;

          background-color: #fbfdff;
          display: flex;
          justify-content: center;
          align-items: center;
          cursor: pointer;
          &:hover {
            border-color: $globalLessBGColor;
            > i {
              color: $globalBGColor;
            }
          }
          > i {
            font-size: 20px;
            color: #8c939d;
          }
        }
      }

      .loginAds-tab-item {
        /* display: flex; */
        align-items: center;
        .loginAds-tab-label {
          display: flex;
          align-items: center;
          font-weight: bold;
        }
        .loginAds-tab-addr {
          display: flex;
          align-items: center;
          .loginAds-tab-addrName {
            width: 150px;
            margin-right: 10px;
          }
          .loginAds-tab-addrVersion {
            width: 120px;
            margin-right: 10px;
          }
          .loginAds-tab-addrUrl {
            flex: 1;
          }
        }
        .loginAds-tab-icon {
          width: 16px;
          height: 16px;
          border-radius: 100px;
          background: $globalBGColor;
          margin-left: 10px;
          display: flex;
          justify-content: center;
          align-items: center;
          cursor: pointer;
          > i {
            color: #fff;
            font-weight: bold;
          }
        }
      }
    }
  }
}
</style>
